// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2372":"css/app.7042","3096":"css/admin-app.7042"}[chunkId] + ".css";
};